import store from '../configureStore';
import isCanadaWebAppHandler from '../helpers/isCanadaWebAppHandler';

/**
 * Checks if the local_url exisits, and returns it.
 * Otherwise returns the API Gateway URL
 */
function get_url(local_url, local_path = '', gateway_path = '') {
  if (local_url) return `${local_url}${local_path}`;

  const gateWayURl = `${isCanadaWebAppHandler() ? process.env.REACT_APP_URL_APIGW_CA : process.env.REACT_APP_URL_APIGW_US}${gateway_path}`;
  return gateWayURl;
}
export const bpBaseUrl = get_url(process.env.REACT_APP_BULK_PICKUP_BASE_URL_LOCAL);
export const baseUrl = get_url(process.env.REACT_APP_URLS_WGW_LOCAL);
export const trackerUrl = get_url(process.env.REACT_APP_URLS_TRACKER_LOCAL);
export const cityBaseUrl = get_url(process.env.REACT_APP_URLS_CITY_BASE_URL_LOCAL);
export const pluginWebappUrl = get_url(process.env.REACT_APP_URL_LOCAL);
export const reportSaveUrl = get_url(process.env.REACT_APP_REP_SAVE_URL_LOCAL);
export const reminderUrl = get_url(process.env.REACT_APP_REMINDER_SIGNUP_URL_LOCAL);
export const notificationsUrl = get_url(process.env.REACT_APP_NEWS_URL_LOCAL);
export const campaignBaseUrl = get_url(process.env.REACT_APP_CAMPAINGN_BACKEND_URL_LOCAL, '/feedback', '/edu/wwtk');
export const pdfDownloadUrl = get_url(process.env.REACT_APP_PDF_URL, '', '/calendar/pdf');
export const pdfSubscribeUrl = get_url(process.env.REACT_APP_PDF_URL, '', '/calendar/pdf/subscribe');
export const iosUrl = process.env.REACT_APP_IOS_URL;
export const iCalUrl = process.env.REACT_APP_ICAL_URL;
export const siteKey = process.env.REACT_APP_RECAPTCHA_KEY;
export const cdnBaseUrl = process.env.REACT_APP_URLS_CDN_BASE_URL;
export const androidUrl = process.env.REACT_APP_ANDROID_URL;
export const primaryColor = process.env.REACT_APP_PRIMARY_COLOR;
export const secondaryColor = process.env.REACT_APP_SECONDARY_COLOR;
export const otherCalUrl = isCanadaWebAppHandler()
  ? process.env.REACT_APP_OTHER_CALENDAR_URL
  : process.env.REACT_APP_OTHER_CALENDAR_URL_US;
export const googleCalendarUrl = isCanadaWebAppHandler()
  ? process.env.REACT_APP_GOOGLE_CALENDAR_URL
  : process.env.REACT_APP_GOOGLE_CALENDAR_URL_US;
export const outlookUrl = process.env.REACT_APP_OUTLOOK_URL;
export const webCampaignBaseUrl = process.env.REACT_APP_URLS_WEB_CAMPAINGN_BASE_URL;

/**
 * @private
 *
 * This function is for fixing the query string
 */
function updateQueryStringParameter(uri, key, value) {
  const re = new RegExp(`([?&])${key}=.*?(&|$)`, 'i');
  const separator = uri.indexOf('?') !== -1 ? '&' : '?';
  if (uri.match(re)) {
    return uri.replace(re, `$1${key}=${value}$2`);
  }
  return `${uri + separator + key}=${value}`;
}

/**
 * @private
 * Api combination function
 */
const buildEndpoint = (prefix, path, lang) => {
  const state = store.store.getState();
  const url = `${prefix}/${path}`;
  if (
    state.config.langs
    && state.config.langs.length
    && lang
  ) {
    return updateQueryStringParameter(url, 'lang', lang);
  }
  return url;
};

/**
 * Api connstructors
 */
export default {
  // WGW
  imageUrl: (path) => `${cdnBaseUrl}/gallery/${path}`,
  materialDetailsApi: (localityId, matId, lang) => buildEndpoint(baseUrl, `wgw/material?locality=${localityId}&material_id=${matId}`, lang),
  getEventsApi: (localityId, matId, lang) => buildEndpoint(baseUrl, `wgw/events?locality=${localityId}&matId=${matId}`, lang),
  getEventDetailsApi: (localityId, event, lang) => buildEndpoint(baseUrl, `wgw/event?locality=${localityId}&event=${event}`, lang),
  getDeposApi: (localityId, matId, location, lang) => buildEndpoint(baseUrl, `wgw/depots?locality=${localityId}&matId=${matId}`, lang),
  getDepoDetailsApi: (localityId, depotId, lang) => buildEndpoint(baseUrl, `wgw/depot?locality=${localityId}&depot_id=${depotId}`, lang),
  getGeneralPage: (localityId, link, lang) => buildEndpoint(baseUrl, `wgw/gpg?locality=${localityId}&page_id=${link.replace('.page', '').replace('gpg/', '')}`, lang),
  getCollectionDetails: (localityId, id, lang) => buildEndpoint(baseUrl, `wgw/collection?locality=${localityId}&coll_id=${id.replace('collection/', '')}&appOnWeb=true`, lang),
  materialListApi: (localityId, lang) => buildEndpoint(baseUrl, `wgw/mats?locality=${localityId}`, lang),
  searchMaterialByTerm: (localityId, term, lang) => buildEndpoint(baseUrl, `wgw/search?locality=${localityId}&q=${term}`, lang),

  // Campaign
  campaignUrl: ({
    projectId, districtId, uuid, lang, zones, campaignSource
  }) => `${webCampaignBaseUrl}/?projectId=${projectId}&districtId=${districtId}&uuid=${uuid}&lang=${lang}&zones=${zones}&campaignSource=${campaignSource}`,
  nationalSurveyUrl: (projectId, districtId, uuid, selectedLang) => `https://campaign.recyclecoach.com/?projectId=${projectId}&districtId=${districtId}&uuid=${uuid}&lang=${selectedLang}&web=true&type=nationalsurvey&runson=webapp`,

  // Zone Setup
  getPluginDetails: (plugin_id, lang_cd) => `${pluginWebappUrl}/webapp/config?plugin_id=${plugin_id}&lang_cd=${lang_cd}`,
  sendPluginTracker: () => `${pluginWebappUrl}/webapp/host`,
  getZoneJson: (projectId, districtId, term) => `${cityBaseUrl}/zone-setup/address/single?sku=${projectId}&district=${districtId}&prompt=undefined&term=${term}`,
  getZoneJsonMulti: (projectString, term) => `${cityBaseUrl}/zone-setup/address/multi?term=${term}&projects=${encodeURIComponent(projectString)}`,
  zoneInfo: (projectId, districtId, lat, lng) => `${cityBaseUrl}/zone-setup/address/geo/zone?project_id=${projectId}&district_id=${districtId}&lat=${lat}&lng=${lng}`,
  getScheduleJson: (projectId, districtId, zone) => `${cityBaseUrl}/zone-setup/zone/schedules?project_id=${projectId}&district_id=${districtId}&zone_id=${zone}`,
  getCollectionJson: (projectId, districtId, zone, lang) => `${cityBaseUrl}/zone-setup/zone/collections?project_id=${projectId}&district_id=${districtId}&zone_id=${zone}&lang_cd=${lang || 'en_US'}`,
  getLatAndLong: (term, uuid, projectId, districtId) => `${cityBaseUrl}/zone-setup/address/geo?address=${term}&uuid=${uuid}&project_id=${projectId}&district_id=${districtId}`,

  // New Stuff
  getNewsApi: (project, district, zoneStr, lang) => buildEndpoint(notificationsUrl, `webapp/notifications?project_id=${project}&district_id=${district}&zone_id=${zoneStr}&appOnWeb=true`, lang),

  // Reminder
  reminderSignUp: `${reminderUrl}`,
  // Report Problem
  problemReporterUrl: () => `${reportSaveUrl}/rap/report-web`,
  getPresignedUrlForImageUpload: (projectId, contentType) => get_url('', '', `/rap/presigned-url-for-upload?project_id=${projectId}&content_type=${contentType}`),

  openPdfCalendar: (
    projectId,
    districtId,
    zoneStr,
    month,
    appStage
  ) => window.open(`${pdfDownloadUrl}?project_id=${projectId}&district_id=${districtId}&zone_id=${zoneStr}&app_stage=${appStage}&month=${month}`, '_blank'),

  pdfSubscribe: () => `${pdfSubscribeUrl}`,

  wwtkFeedback: (type) => ({
    poll: `${campaignBaseUrl}/submit-poll`,
    quiz: `${campaignBaseUrl}/submit-quiz`
  })[type],

  // Campaign
  getCampaignImage: (postfix) => `${cdnBaseUrl}/campaigns/${postfix}`,

  // Help
  getNextPickUp: (
    projectId, districtId, zoneStr, collectionId
  ) => `${cityBaseUrl}/zone-setup/zone/next-schedule?project_id=${projectId}&district_id=${districtId}&zone_id=${zoneStr}&col_type_id=${collectionId.replace('collection-', '')}`,

  // Bulk Pickup

  getBpServiceEligibility: (projectId, districtId, zoneStr) => `${bpBaseUrl}/bulk/service-eligibility?project_id=${projectId}&district_id=${districtId}&zone_id=${zoneStr}`,
  getBpSchedules: (projectId, districtId, zoneStr) => `${bpBaseUrl}/bulk/schedules?project_id=${projectId}&district_id=${districtId}&zone_id=${zoneStr}`,
  bpCheckPaymentStatus: (id) => `${bpBaseUrl}/bulk/check_payment_status?id=${id}`,
  getPluginDetailsBpOnly: (projectId, districtId) => `${pluginWebappUrl}/webapp/bulk-only?project_id=${projectId}&district_id=${districtId}`,
  submitBPRequest: () => get_url('', '', '/bulk/request'),
  trackerApi: `${trackerUrl}/tr`,
};
